const DEPLOY_MODE = "prod";

module.exports = {
    API_HOST: DEPLOY_MODE === "dev" ? "http://192.168.0.55:3000" : "https://api.pressandco.fr",
    WEBSITE_URL: DEPLOY_MODE === "dev" ? "http://127.0.1.1:3100" : "https://pressandco.fr",
    HIDDEN_MENUS: ["config/message", "config/variable", "config/timetable", "config/delivery"],

    ORDER_STATUS_ID_REF: 
    {
        1: "COMMANDING",
        2: "STARTED",
        3: "RECEIVING",
        4: "RECEIVED",
        5: "PAID",
        6: "TREATED",
        7: "RETURNING",
        8: "RETURNED",
        9: "CANCELLED",
    },

    ORDER_STATUS_REF_ID: 
    {
        "COMMANDING": 1,
        "STARTED": 2,
        "RECEIVING": 3,
        "RECEIVED": 4,
        "PAID": 5,
        "TREATED": 6,
        "RETURNING": 7,
        "RETURNED": 8,
        "CANCELLED": 9,
    },
}